export default "__VITE_ASSET__DMZWDAt2__"